
export default class MilitaryDiscipline {

    id!: number;
    name!: string;
    description!: string;
    write!: boolean;
    sortPriority!: boolean;

    public static fromResponse(data: any): MilitaryDiscipline {

        const result: MilitaryDiscipline = new MilitaryDiscipline();

        if (data.id != undefined) {
            result.id = data.id;
        }

        if (data.name != undefined) {
            result.name = data.name;
        }

        if (data.description != undefined) {
            result.description = data.description;
        }

        if (data.write != undefined) {
            result.write = data.write;
        }

        if (data.sortPriority != undefined) {
            result.sortPriority = data.sortPriority;
        }

        return result;

    }

}